import { mountApp } from '@oui/app-core/src/lib/mountApp';

import App from '@src/App';

mountApp(App);
